import {
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  InputProps,
  StackProps,
} from '@chakra-ui/react';
import IconSearch from 'assets/icons/icon-search.svg?react';
import { useSearchContext } from 'contexts/SearchContext';
import useDebounce from 'hooks/useDebounce';
import { PropsWithChildren, useEffect, useState } from 'react';

type SearchBarProps = PropsWithChildren<
  StackProps & {
    placeholder: string;
    inputProps?: InputProps;
  }
>;

export default function SearchBar({
  children,
  placeholder,
  inputProps = {},
  ...props
}: SearchBarProps) {
  const { query, setQuery } = useSearchContext();
  const [searchText, setSearchText] = useState(query);

  const debouncedText = useDebounce(searchText, 500);

  useEffect(() => {
    if (query !== debouncedText) {
      setQuery(debouncedText);
    }
  }, [debouncedText, setQuery, query]);

  return (
    <HStack w="full" spacing="28px" mb="30px" {...props}>
      <InputGroup size="sm">
        <InputLeftElement pointerEvents="none">
          <IconSearch />
        </InputLeftElement>
        <Input
          placeholder={placeholder}
          {...inputProps}
          onChange={(e) => setSearchText(e.target.value)}
          value={searchText}
        />
      </InputGroup>
      {children}
    </HStack>
  );
}
